interface Config {
  mode: string;
  baseURL: string,
  SAAS: string;
  ISV: string,
  MARKETPLACE_REST_API_URL: string;
  APP_ENGINE_API_URL: string;
  REVEX_SAAS: string;
  stripeKey?: string;
  REVEX_BACKEND_LC_PHONE_URL: string;
}

const config: { [key: string]: Config } = {
  development: {
    mode: "dev",
    baseURL:"https://staging.api.leadconnectorhq.com",
    SAAS: "https://staging.backend.leadconnectorhq.com/saas_service",
    ISV: "https://staging.backend.leadconnectorhq.com/isv_service",
    MARKETPLACE_REST_API_URL: "https://staging.backend.leadconnectorhq.com",
    APP_ENGINE_API_URL: "https://staging.api.leadconnectorhq.com",
    REVEX_SAAS: "https://staging.backend.leadconnectorhq.com/saas-api",
    stripeKey: "pk_test_WvH5LGch2F7bqyIJ6gVMu3iE",
    REVEX_BACKEND_LC_PHONE_URL: "https://staging.backend.leadconnectorhq.com/phone-system"
  },
  staging: {
    mode: "staging",
    baseURL:"https://staging.api.leadconnectorhq.com",
    SAAS: "https://staging.backend.leadconnectorhq.com/saas_service",
    ISV: "https://staging.backend.leadconnectorhq.com/isv_service",
    MARKETPLACE_REST_API_URL: "https://staging.backend.leadconnectorhq.com",
    APP_ENGINE_API_URL: "https://staging.api.leadconnectorhq.com",
    REVEX_SAAS: "https://staging.backend.leadconnectorhq.com/saas-api",
    stripeKey: "pk_test_WvH5LGch2F7bqyIJ6gVMu3iE",
    REVEX_BACKEND_LC_PHONE_URL: "https://staging.backend.leadconnectorhq.com/phone-system"
  },
  interop:{
    mode: "interop",
    baseURL:"https://staging.api.leadconnectorhq.com",
    SAAS: "https://interop.backend.leadconnectorhq.com/saas_service",
    ISV: "https://interop.backend.leadconnectorhq.com/isv_service",
    MARKETPLACE_REST_API_URL: "https://interop.backend.leadconnectorhq.com",
    APP_ENGINE_API_URL: "https://staging.api.leadconnectorhq.com",
    REVEX_SAAS: "https://interop.backend.leadconnectorhq.com/saas-api",
    stripeKey: "pk_test_WvH5LGch2F7bqyIJ6gVMu3iE",
    REVEX_BACKEND_LC_PHONE_URL: "https://interop.backend.leadconnectorhq.com/phone-system"
  },
  beta: {
    mode: "beta",
    baseURL: "https://backend.leadconnectorhq.com/appengine",
    SAAS: "https://backend.leadconnectorhq.com/saas_service",
    ISV: "https://backend.leadconnectorhq.com/isv_service",
    MARKETPLACE_REST_API_URL: "https://backend.leadconnectorhq.com",
    APP_ENGINE_API_URL: "https://backend.leadconnectorhq.com/appengine",
    REVEX_SAAS: "https://backend.leadconnectorhq.com/saas-api",
    stripeKey: "pk_live_MtxwO3obi7pfD7UZlGkfR2yj",
    REVEX_BACKEND_LC_PHONE_URL: "https://backend.leadconnectorhq.com/phone-system"
  },
  production: {
    mode: "production",
    baseURL: "https://backend.leadconnectorhq.com/appengine",
    SAAS: "https://backend.leadconnectorhq.com/saas_service",
    ISV: "https://backend.leadconnectorhq.com/isv_service",
    MARKETPLACE_REST_API_URL: "https://backend.leadconnectorhq.com",
    APP_ENGINE_API_URL: "https://backend.leadconnectorhq.com/appengine",
    REVEX_SAAS: "https://backend.leadconnectorhq.com/saas-api",
    stripeKey: "pk_live_MtxwO3obi7pfD7UZlGkfR2yj",
    REVEX_BACKEND_LC_PHONE_URL: "https://backend.leadconnectorhq.com/phone-system"
  },
};

const override = false;

const overrideConfig = {
  override: true,
};
const envConfig = config[process.env.NODE_ENV];

export default override ? { ...envConfig, ...overrideConfig } : envConfig;
